<script setup lang="ts">
const documentId = inject("documentId") as any;
const documentEvaluativeParagraphStore =
  useDocumentEvaluativeParagraphsStore(documentId);
const {
  bodyParagraphs,
  evaluativeParagraphIdToPositionMap,
  mapParagraphPositionToBodyParagraphPosition,
} = storeToRefs(documentEvaluativeParagraphStore);

const documentSelectionStore = useDocumentSelectionStore(documentId);
const { evaluativeParagraphIndexToHighlight } = storeToRefs(
  documentSelectionStore
);

const documentChecklistStore = useDocumentChecklistStore(documentId);
const { defaultParagraphPositionsData } = storeToRefs(documentChecklistStore);

const timeout = ref<NodeJS.Timeout | null>(null);

const highlightParagraph = (evaluativeParagraph: EvaluativeParagraph) => {
  if (timeout.value) {
    clearTimeout(timeout.value);
  }
  timeout.value = setTimeout(() => {
    documentSelectionStore.setEvaluativeParagraphIndexToHighlight(
      evaluativeParagraph.index
    );

    var firstTokenPosition = evaluativeParagraph.startIndex;
    var documentTokenPositionsStore =
      useDocumentTokenIdPositionMapStore(documentId);

    var tokenId =
      documentTokenPositionsStore.tokenIdFromLocalIndex(firstTokenPosition);

    // Get the element with attribute data-token-id=tokenId
    var tokenElement = document.querySelector(`[data-token-id="${tokenId}"]`);

    if (tokenElement == undefined) return;

    // Scroll to the token element
    tokenElement.scrollIntoView({ behavior: "smooth", block: "start" });
  }, 500);
};

const clearHighlight = () => {
  if (timeout.value) {
    clearTimeout(timeout.value);
  }

  documentSelectionStore.clearEvaluativeParagraphIndexToHighlight();
};
</script>

<template>
  <BasePopover placement="bottom-start" align="start">
    <BaseIconButton :size="32" tooltip="Formatting legend">
      <icon name="material-symbols:help" size="16" />
    </BaseIconButton>
    <template #content>
      <div class="bg-surface rounded w-[250px] p-1 max-h-[300px] overflow-auto">
        <div class="flex flex-row items-center px-2 py-2">
          <span
            class="text-danger-default text-[16px] w-4 h-4 flex items-center justify-center mr-2"
            >•</span
          >
          <span> Space </span>
        </div>
        <div class="flex flex-row items-center px-2 py-2">
          <span
            class="text-danger-default text-[16px] w-4 h-4 flex items-center justify-center mr-2"
            >→</span
          >
          <span> Indent / Tab </span>
        </div>
        <div class="flex flex-row items-center px-2 py-2">
          <span
            class="text-danger-default text-[16px] w-4 h-4 flex items-center justify-center mr-2"
          >
            <icon name="fa-solid:paragraph" />
          </span>
          <span>Paragraph Break</span>
        </div>

        <div
          v-for="paragraph in bodyParagraphs"
          :key="paragraph.id"
          class="flex flex-row items-center px-2 py-2 hover:bg-light-default rounded"
          @mouseenter="highlightParagraph(paragraph)"
          @mouseleave="clearHighlight"
        >
          <div
            class="w-4 h-4 rounded mr-2"
            :class="{
              'bg-primary-default bg-opacity-10 ': paragraph.index % 2 == 0,
              'bg-secondary-default bg-opacity-10': paragraph.index % 2 == 1,
            }"
          />
          <span> Paragraph </span>
        </div>
      </div>
    </template>
  </BasePopover>
</template>

<style scoped></style>
